import { useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Truck } from "lucide-react";
import { TrackingTimeline } from "@/components/TrackingTimeline";

export const SHIPMENT_STEPS = ["Shipped", "In transit", "Out for delivery", "Delivered"];

export const ShipmentManager = ({ order, onUpdated }) => {
  const [carrier, setCarrier] = useState(order.carrier || "");
  const [num, setNum] = useState(order.tracking_number || "");
  const [busy, setBusy] = useState(false);

  const post = async (body, msg) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/orders/${order.order_id}/tracking`, body);
      toast.success(msg);
      onUpdated?.(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to update tracking");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3" data-testid={`shipment-mgr-${order.order_id}`}>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input data-testid={`carrier-${order.order_id}`} placeholder="Carrier (e.g. DHL)" value={carrier} onChange={(e) => setCarrier(e.target.value)} className="sm:max-w-[160px]" />
        <Input data-testid={`tracking-num-${order.order_id}`} placeholder="Tracking code from agent" value={num} onChange={(e) => setNum(e.target.value)} />
        <Button data-testid={`save-tracking-${order.order_id}`} disabled={busy} onClick={() => post({ carrier, tracking_number: num }, "Tracking saved")} className="rounded-full whitespace-nowrap"><Truck className="w-4 h-4 mr-1" />Save</Button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {SHIPMENT_STEPS.map((s) => (
          <Button key={s} data-testid={`step-${s.replace(/\s+/g, "-")}-${order.order_id}`} size="sm" variant="outline" disabled={busy} onClick={() => post({ status: s }, `Marked as: ${s}`)}>{s}</Button>
        ))}
      </div>
      <TrackingTimeline order={order} />
    </div>
  );
};
